var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIconPriceRange = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 28 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.258 14.286c.695 0 1.258-.575 1.258-1.285s-.563-1.286-1.258-1.286C1.563 11.715 1 12.29 1 13c0 .71.563 1.285 1.258 1.285ZM25.742 14.286c.695 0 1.258-.575 1.258-1.285s-.563-1.286-1.258-1.286c-.694 0-1.258.575-1.258 1.286 0 .71.564 1.285 1.258 1.285ZM23.647 3.574v2.572h-2.516M4.355 22.431v-2.572h2.517",
  stroke: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.684 14.227C25.084 20.278 20.08 25 14 25c-3.988 0-7.514-2.035-9.636-5.143M2.324 11.72C2.95 5.692 7.94 1 14 1c3.989 0 7.515 2.036 9.637 5.143",
  stroke: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.562 15.499c0 1.376 1.095 2.494 2.44 2.494 1.347 0 2.442-1.118 2.442-2.494 0-1.376-2.441-2.495-2.441-2.495s-2.44-1.118-2.44-2.494c0-1.376 1.094-2.494 2.44-2.494 1.346 0 2.44 1.118 2.44 2.494M13.998 8.006V5.512M13.998 17.992v2.495",
  stroke: "currentColor"
})));

export default SvgIconPriceRange;